import React, { useState, useRef } from 'react'
import Box from '@material-ui/core/Box'
import propTypes from 'prop-types'
import Select from 'react-select'
import { Formik, Form as FormikForm, useField } from 'formik'

import { Modal, ModalHeader, ModalContent } from './index'
import { Button } from '../Button'
import { CheckboxWithLabel } from '../Form/Fields'

export const CreateJointPlanModal = ({ open, name, clients, createJointScenarioPath }) => {
  const [creatingJointPlan, setCreatingJointPlan] = useState(false)
  const formRef = useRef(null)

  return (
    <Modal hideCloseButton open={open}>
      <ModalHeader>
        Create a joint plan
      </ModalHeader>
      <ModalContent className='centered'>
        <Formik
          initialValues={{
            client: null,
            is_married: false
          }}
          onSubmit={(_values) => {
            setCreatingJointPlan(true)
            formRef.current.submit()
          }}
        >
          <FormikForm method='post' action={createJointScenarioPath} ref={formRef}>
            <FormContent
              clientName={name}
              clients={clients}
              creatingJointPlan={creatingJointPlan}
            />
          </FormikForm>
        </Formik>
      </ModalContent>
    </Modal>
  )
}

const FormContent = ({ clients, clientName, creatingJointPlan }) => {
  const [field, meta, helpers] = useField('client')
  const { setValue } = helpers
  const { value, name } = field

  const csrfToken = document.querySelector('meta[name="csrf-token"]').content

  return (
    <>
      <input value={csrfToken} type='hidden' name='authenticity_token' />
      <h5 className='text-center remove-margin'>You are about to create a joint plan for {clientName}</h5>
      <h5 className='text-center'>Please select who you would like to link them to</h5>
      <Box>
        <Select
          getOptionLabel={(option) => option['name']}
          getOptionValue={(option) => option['id']}
          maxHeight={100}
          name={name}
          styles={{
            input: () => ({
              height: '2rem'
            })
          }}
          options={clients}
          value={value}
          noOptionsMessage={() => `You don't have other active clients without joint plans`}
          onChange={(option) => setValue(option)}
        />
      </Box>
      { value &&
        <Box
          display={value ? 'flex' : 'none'}
          flexDirection='column'
          alignItems='center'
        >
          <CheckboxWithLabel
            label={`The client is ${clientName}'s spouse`}
            name='is_married'
          />
          <h5 className='remove-margin'>You have selected: {value.name}</h5>
        </Box>
      }
      <Box
        className='flex justify-center my-4 gap-4'
      >
        <Button disabled={creatingJointPlan} secondary onClick={() => window.history.back()}>Go back</Button>
        {value &&
          <Button disabled={creatingJointPlan} primary type='submit'>{creatingJointPlan ? 'Creating...' : 'Continue'}</Button>
        }
      </Box>
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
      >
        <small>Can't find who you're looking for?</small>
        <small>Make sure they're onboarded onto wealthbit and they aren't archived</small>
      </Box>
    </>
  )
}

CreateJointPlanModal.propTypes = {
  open: propTypes.bool.isRequired,
  name: propTypes.string.isRequired,
  clients: propTypes.arrayOf(Object).isRequired,
  onCreate: propTypes.func.isRequired,
  creatingJointPlan: propTypes.bool.isRequired
}
